import { formatRateToPercent } from 'utils/app';
import type { VoiceChatViewingFunnelType } from 'types/api/voiceChatReportRefResponseType';

import type { JSX } from 'react';

/**
 * 視聴ファネル表示コンポーネント（EV-vc-report-01）。
 * パラメータモード ON のコンテンツでのみ表示（viewingFunnel=null のとき非表示）。
 */
export default function WsReportVoiceChatFunnel(props: {
  viewingFunnel: VoiceChatViewingFunnelType | null;
}): JSX.Element | null {
  const { viewingFunnel } = props;
  if (!viewingFunnel) return null;

  const {
    displayedCount,
    startedCount,
    completedCount,
    abandonedCount,
    abandonedRate,
    reachedByQuestion,
  } = viewingFunnel;

  return (
    <section className="section-statistical">
      <div className="container">
        <h3 className="title-section title-md">視聴ファネル</h3>
        <div className="row row-cols-2 row-cols-lg-4">
          <div>
            <div className="card card-white">
              <div className="card-body">
                <div className="d-flex d-flex-statistical">
                  <div className="flex-shrink-0 flex-left">
                    <small>表示人数</small>
                    {displayedCount}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="card card-white">
              <div className="card-body">
                <div className="d-flex d-flex-statistical">
                  <div className="flex-shrink-0 flex-left">
                    <small>開始人数</small>
                    {startedCount}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="card card-white">
              <div className="card-body">
                <div className="d-flex d-flex-statistical">
                  <div className="flex-shrink-0 flex-left">
                    <small>完了人数</small>
                    {completedCount}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="card card-white">
              <div className="card-body">
                <div className="d-flex d-flex-statistical">
                  <div className="flex-shrink-0 flex-left">
                    <small>離脱人数（離脱率）</small>
                    {abandonedCount}（{`${formatRateToPercent(abandonedRate)}%`}）
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {reachedByQuestion.length > 0 && (
          <div className="box-common shadow-none" style={{ marginTop: 16 }}>
            <h4 className="title-section title-sm">設問別到達人数</h4>
            <table className="vcr-table">
              <thead>
                <tr>
                  <th>設問番号</th>
                  <th>到達人数</th>
                </tr>
              </thead>
              <tbody>
                {reachedByQuestion.map(item => (
                  <tr key={item.questionNo}>
                    <td>設問{item.questionNo}</td>
                    <td>{item.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
}
